import {Button} from '@/components/ui/button/Button'
import {ModalBody, ModalHeader, ModalParagraph, ModalTitle} from '@/components/ui/modal-atoms/ModalAtoms'
import styled, {css} from 'styled-components'

export const StyledFollowUpModalButton = styled(Button)<{$isReadOnly?: boolean}>`
    text-decoration: ${({$isReadOnly}) => ($isReadOnly ? 'none' : 'underline')};
    pointer-events: ${({$isReadOnly}) => ($isReadOnly ? 'none' : 'auto')};
`

export const StyledTreatmentRequestFollowUpModalHeader = styled(ModalHeader)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 2}px;
    `
)

export const StyledTreatmentRequestFollowUpModalTitle = styled(ModalTitle)(
    ({theme: {typography}}) => css`
        ${typography.textXl};
    `
)

export const StyledTreatmentRequestFollowUpModalBody = styled(ModalBody)(
    () => css`
        display: flex;
        flex-direction: column;
        gap: 0;
        padding: 0;
        overflow: visible;
    `
)

export const StyledTreatmentRequestFollowUpModalSubtitle = styled(ModalParagraph)(
    ({theme: {typography, palette}}) => css`
        ${typography.textMd};
        color: ${palette.neutral['600']};
    `
)
